import React from 'react';
import style from './style.scss';

export default class VerticalStack extends React.Component<{}, {}> {
  render() {
    return <div className={style.verticalStack}>{this.props.children}</div>;
  }
}
